import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Link } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import termsContent from '../../../components/terms-of-use/terms-of-use.json';
import aboutUsContent from '../../../components/about-us/about-us.json';

const style = {
  position: 'absolute',
  top: '10%',
  left: '10%',
  height: "80%",
  width: "80%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
};

export default function TermsOfUseModal(props) {
  const [open, setOpen] = React.useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    props.closeModal();
    setOpen(false)
  };

  // Helper function to render text with bold spans
  const renderContentWithBold = (content) => {
    const parts = content.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <span key={index} style={{ fontWeight: 700 }}>{part.slice(2, -2)}</span>;
      }
      return part;
    });
  };

  // Helper function to render content with line breaks
  const renderContent = (content) => {
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {renderContentWithBold(line)}
        {index < content.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <CancelOutlinedIcon
            onClick={() => handleClose()}
            sx={{
              ml: 0, mt: 0, top: `calc(10% - 12px)`, left: `calc(90% - 13px)`,
              height: 24, width: 26, cursor: 'pointer', position: 'fixed', zIndex: 9999
            }}
          />
          
          {props.privacyPolicy && (
            <Box sx={style}>
              <Typography id="modal-modal-description" sx={{ ml: 4, mr: 4, mt: 4, fontWeight: 600 }} variant="h5">
                {termsContent.privacyPolicy.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ ml: 4, mr: 4, mt: 4 }}>
                {renderContent(termsContent.privacyPolicy.content)}
                <br /><br />
                If you have any questions or concerns about our privacy policy, please contact us at{' '}
                <Link href="mailto:support@vtrender.com">support@vtrender.com</Link>
              </Typography>
            </Box>
          )}

          {props.contactInfo && (
            <Box sx={style}>
              <Typography id="modal-modal-description" sx={{ ml: 4, mr: 4, mt: 4, fontWeight: 600 }} variant="h5">
                {aboutUsContent.contactInfo.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ ml: 4, mr: 4, mt: 4 }}>
                <span style={{ fontWeight: 700 }}>Contact number:</span> {aboutUsContent.contactInfo.contactNumber}
                <br /><br />
                <span style={{ fontWeight: 700 }}>Email address:</span>{' '}
                {aboutUsContent.contactInfo.emailAddresses.map((email, index) => (
                  <React.Fragment key={index}>
                    <u>{email}</u>
                    {index < aboutUsContent.contactInfo.emailAddresses.length - 1 && ' or '}
                  </React.Fragment>
                ))}
                <br /><br />
                <span style={{ fontWeight: 700 }}>Address:</span>
                <Typography id="modal-modal-description" sx={{ mt: -3, ml: 10 }}>
                  {aboutUsContent.contactInfo.address.company} <br />
                  {aboutUsContent.contactInfo.address.line1} <br />
                  {aboutUsContent.contactInfo.address.line2} <br />
                  {aboutUsContent.contactInfo.address.line3} <br />
                  {aboutUsContent.contactInfo.address.line4} <br />
                  {aboutUsContent.contactInfo.address.line5} <br />
                  {aboutUsContent.contactInfo.address.line6} <br />
                </Typography>
                <br /><br />
              </Typography>
            </Box>
          )}

          {props.refundPolicy && (
            <Box sx={style}>
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h5">
                {termsContent.refundPolicy.title1}
                <br />
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.refundPolicy.content1)}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 700 }} variant="h5">
                {termsContent.refundPolicy.title2}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.refundPolicy.content2)}
              </Typography>
            </Box>
          )}

          {props.aboutUs && (
            <Box sx={style}>
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h5">
                {aboutUsContent.aboutUs.title}
                <br />
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(aboutUsContent.aboutUs.content)}
                <br />
              </Typography>
            </Box>
          )}

          {!props.privacyPolicy && !props.contactInfo && !props.refundPolicy && !props.aboutUs && (
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h4">
                {termsContent.termsOfUse.title}
              </Typography>

              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.introduction)}
                <br /><br />
              </Typography>

              <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: 700 }} variant="subtitle1">
                {termsContent.termsOfUse.pleaseRead}
                <br />
              </Typography>

              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.agreement)}
              </Typography>

              {/* Ownership Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.ownership.title}
                <br />
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.ownership.content)}
              </Typography>

              {/* Disclaimer Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.disclaimer.title}
                <br />
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.disclaimer.content)}
              </Typography>

              {/* Cancellations and Refunds Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="subtitle1">
                {termsContent.termsOfUse.sections.cancellationsRefunds.title}
                <br />
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.cancellationsRefunds.content)}
              </Typography>

              {/* License to Use Service Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="subtitle1">
                {termsContent.termsOfUse.sections.licenseToUse.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.licenseToUse.content)}
              </Typography>

              {/* Limitations of Rights Section */}
              <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, fontWeight: 600 }} variant="subtitle1">
                {termsContent.termsOfUse.sections.limitationsOfRights.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.limitationsOfRights.content)}
              </Typography>

              {/* Materials Provided Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="subtitle1">
                {termsContent.termsOfUse.sections.materialsProvided.title}
              </Typography>
              <br />
              {renderContent(termsContent.termsOfUse.sections.materialsProvided.content)}

              {/* Privacy Policy Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.privacyPolicyInTerms.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.privacyPolicyInTerms.content)}
                <br /><br />
                If you have any questions or concerns about our privacy policy, please contact us at{' '}
                <Link href="mailto:support@vtrender.com">support@vtrender.com</Link>
              </Typography>

              {/* Edits to Content Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.editsToContent.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.editsToContent.content)}
              </Typography>

              {/* Copyright Infringement Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.copyrightInfringement.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.copyrightInfringement.content)}
              </Typography>

              {/* Disclaimer of Warranty Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.disclaimerOfWarranty.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.disclaimerOfWarranty.content)}
              </Typography>

              {/* Limitation of Liability Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.limitationOfLiability.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.limitationOfLiability.content)}
              </Typography>

              {/* Release Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.release.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.release.content)}
              </Typography>

              {/* Arbitration Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.arbitration.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.arbitration.content)}
              </Typography>

              {/* Miscellaneous Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 600 }} variant="h6">
                {termsContent.termsOfUse.sections.miscellaneous.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.miscellaneous.content)}
              </Typography>

              {/* No Refund Policy Section */}
              <Typography id="modal-modal-description" sx={{ mt: 4, fontWeight: 700 }} variant="h6">
                {termsContent.termsOfUse.sections.noRefundPolicyInTerms.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {renderContent(termsContent.termsOfUse.sections.noRefundPolicyInTerms.content)}
              </Typography>
            </Box>
          )}
        </>
      </Modal>
    </div>
  );
}